import {MotionProps, Transition, Variant} from 'motion/react';

type TypedVariants = {
  [key in 'initial' | 'animate' | 'exit']: Variant;
};

/**
 * This function will return props for the animated element.
 * @param variants
 * @param transition
 */
export const getMotionProps = (
  variants: TypedVariants,
  transition: Transition = {duration: 0.1, type: 'tween'},
): MotionProps => ({
  variants,
  initial: 'initial',
  animate: 'animate',
  exit: 'exit',
  transition,
});
